module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Pay"
  }, [_c('div', {
    staticClass: "columns is-vcentered is-centered"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("Support operational costs")]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-large is-pink",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.percentage()
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("Our monthly rent is "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.funds.monthlyRentTax) + "€")]), _vm._v(".\n      Our account balance is "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.funds.balance) + "€")]), _vm._v(" at the moment.\n      We are missing "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.funds.missingFunds) + "€")]), _vm._v(" for another month.\n      If you like what we do, you can support our operations by donating 👇")]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-large is-pink",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.percentage()
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("⚡️Lightning Network fan? "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.donations.tippinme
    }
  }, [_vm._v("We are supporting LN too 😍")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tippin-button",
      "data-dest": "progressbarsk"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": _vm.donations.tippinme,
      "target": "_blank"
    }
  }, [_vm._v("Support with ⚡️LN")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": _vm.donations.kyber,
      "name": "KyberWidget - Powered by KyberNetwork",
      "title": "Pay with tokens",
      "target": "_blank"
    }
  }, [_vm._v("Pay with tokens")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": _vm.donations.kyber001,
      "name": "KyberWidget - Powered by KyberNetwork",
      "title": "Pay with tokens",
      "target": "_blank"
    }
  }, [_vm._v("Pay 0.01 ETH with tokens")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 content"
  }, [_c('h1', [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": _vm.donations.daicard
    }
  }, [_vm._v("$10 DAI via 💳DAICARD")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("Ethereum, DAI")]), _vm._v(" "), _c('p', {
    staticClass: "title has-text-white"
  }, [_c('a', {
    attrs: {
      "href": ("ethereum:" + (_vm.donations.ethereum.to))
    }
  }, [_vm._v(_vm._s(_vm.donations.ethereum.to))])]), _vm._v(" "), _c('vue-qr', {
    attrs: {
      "logoSrc": "/static/img/partners/ethereum-1-logo-svg-vector.svg",
      "correctLevel": 1,
      "logoScale": 0.1,
      "text": ("ethereum:" + (_vm.donations.ethereum.to) + "?value=" + (_vm.donations.ethereum.value)),
      "size": 300,
      "dotScale": 1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("₿itcoin "), _c('a', {
    attrs: {
      "href": ("bitcoin:" + (_vm.donations.bitcoin))
    }
  }, [_vm._v(_vm._s(_vm.donations.bitcoin))])]), _vm._v(" "), _c('vue-qr', {
    attrs: {
      "logoSrc": "/static/img/partners/Bitcoin.svg",
      "correctLevel": 3,
      "logoScale": 0.2,
      "text": ("bitcoin:" + (_vm.donations.bitcoin)),
      "size": 300,
      "dotScale": 1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("Łitecoin "), _c('a', {
    attrs: {
      "href": ("litecoin:" + (_vm.donations.litecoin))
    }
  }, [_vm._v(_vm._s(_vm.donations.litecoin))])]), _vm._v(" "), _c('vue-qr', {
    attrs: {
      "logoSrc": "/static/img/partners/Litecoin.svg",
      "correctLevel": 3,
      "logoScale": 0.2,
      "text": ("litecoin:" + (_vm.donations.litecoin)),
      "size": 300,
      "dotScale": 1
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('iframe', {
    attrs: {
      "src": "https://progressbar.darujme.sk/3448/",
      "frameborder": "0",
      "scrolling": "no",
      "width": "300",
      "height": "550",
      "id": "darujme-widget"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a0e237","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay.vue
// module id = 249
// module chunks = 2